"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefinements = void 0;
const react_1 = require("react");
const types_1 = require("@groupby/enrich-sdk/resource/_jsonapi/types");
const predicate_language_1 = require("@groupby/predicate-language");
const react_redux_1 = require("react-redux");
const hooks_1 = require("../../hooks");
const localization_1 = require("../../localization");
const creators_1 = require("../../store/actions/creators");
const selectors_1 = require("../../store/selectors");
const useRefinements = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const client = (0, hooks_1.useEnrichClient)();
    const { addError } = (0, hooks_1.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const selectedOrganizations = (0, selectors_1.useSelectedOrganizationsSelector)();
    const productsIncludedTaxonomyClassIds = (0, selectors_1.useProductsIncludedTaxonomyClassIds)();
    const loadRefinements = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        try {
            dispatch((0, creators_1.refinementsSetLoading)(true));
            const payload = { response: {} };
            const filter = new predicate_language_1.PredicateBuilder((0, predicate_language_1.where)((0, predicate_language_1.f) `organizationId`, '@<', selectedOrganizations.map(({ id }) => (0, predicate_language_1.uuid)(id))));
            yield client.products.getPage({
                filter,
                fields: { meta: [types_1.CollectionMetaParam.REFINEMENTS] },
                page: {
                    limit: 0,
                },
            }, payload);
            dispatch((0, creators_1.clearNotExistTaxonomyClasses)(productsIncludedTaxonomyClassIds.filter((item) => { var _a, _b; return !((_b = (_a = payload.response.meta) === null || _a === void 0 ? void 0 : _a.beta) === null || _b === void 0 ? void 0 : _b.refinements.classIds.includes(item)); })));
            dispatch((0, creators_1.refinementsSetData)((_b = (_a = payload.response.meta) === null || _a === void 0 ? void 0 : _a.beta) === null || _b === void 0 ? void 0 : _b.refinements));
        }
        catch (_c) {
            addError(t({ key: 'PRODUCT_REFINEMENTS_LOADING_ERROR' }));
            dispatch((0, creators_1.refinementsSetData)({ categoryIds: [], classIds: [], actualAttributes: [] }));
        }
        finally {
            dispatch((0, creators_1.refinementsSetLoading)(false));
        }
    }), [selectedOrganizations, productsIncludedTaxonomyClassIds, addError, t, dispatch, client]);
    return loadRefinements;
};
exports.useRefinements = useRefinements;
exports.default = exports.useRefinements;
